<template>
	<SectionCard title="Sales tax USA per Stato" icon="mdi-flag-variant-outline" :subtitle="`soglie di nexus economico · anno ${report.period.year}`" no-padding data-tour="us">
		<v-simple-table dense>
			<thead>
				<tr>
					<th>Stato</th>
					<th class="text-right">Vendite dirette</th>
					<th class="text-right">Vendite marketplace</th>
					<th class="text-right">Ordini contati</th>
					<th class="text-right" title="Vendite contate per la soglia nell'anno precedente: anche quelle fanno scattare l'obbligo">Anno precedente</th>
					<th>Soglia</th>
					<th style="min-width: 160px">Avanzamento</th>
					<th>Situazione</th>
					<th class="text-right">Sales tax trattenuta</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="s in report.nexus.states" :key="s.state">
					<td>
						<span class="fo-code">{{ s.state }}</span> {{ s.name }}
					</td>
					<td class="text-right">{{ usd(s.current.directUsd) }}</td>
					<td class="text-right">
						{{ usd(s.current.marketplaceUsd) }}
						<div v-if="!s.rule.includeMarketplace && s.current.marketplaceUsd" class="fo-muted">non conta per la soglia</div>
					</td>
					<td class="text-right">{{ formatNumber(s.current.orders) }}</td>
					<td class="text-right">
						{{ usd(s.previous.usd) }}
						<div class="fo-muted">{{ formatNumber(s.previous.orders) }} ordini</div>
					</td>
					<td class="fo-muted text-no-wrap">{{ ruleText(s.rule) }}</td>
					<td>
						<v-progress-linear v-if="!s.rule.noTax" :value="Math.min(s.pct, 100)" :color="nexus(s.status).color" height="6" rounded />
						<div class="fo-muted">{{ s.rule.noTax ? '—' : `${String(s.pct).replace('.', ',')}%` }}</div>
					</td>
					<td>
						<v-chip x-small label outlined :color="nexus(s.status).color">{{ nexus(s.status).label }}</v-chip>
					</td>
					<td class="text-right">{{ s.current.tax ? formatEurCents(s.current.tax) : '—' }}</td>
				</tr>
				<tr v-if="!report.nexus.states.length">
					<td colspan="9" class="text-center grey--text py-4">Nessuna vendita negli Stati Uniti nell’anno.</td>
				</tr>
			</tbody>
		</v-simple-table>
		<div class="fo-muted pa-3">
			Le soglie si misurano sull’anno solare in corso o precedente (o sugli ultimi 12 mesi, dove lo Stato lo prevede), in dollari. Sui marketplace la sales tax la versa il marketplace facilitator; per
			le vendite dirette, oltre la soglia, serve la registrazione nello Stato. Valori di partenza da verificare con il consulente: si correggono nelle impostazioni.
			<span v-if="report.nexus.unknownStateOrders"> {{ report.nexus.unknownStateOrders }} ordini USA non hanno lo Stato e non sono contati.</span>
		</div>
	</SectionCard>
</template>

<script>
import SectionCard from '@/components/core/SectionCard.vue';
import { formatEurCents, formatNumber } from '@/components/finance/format';
import { NEXUS } from './labels';

const usdFormat = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });

export default {
	name: 'ForeignUs',
	components: { SectionCard },
	props: {
		report: { type: Object, required: true },
	},
	methods: {
		formatEurCents,
		formatNumber,
		usd: v => usdFormat.format(+v || 0),
		nexus: s => NEXUS[s] || NEXUS.below,
		ruleText(rule) {
			if (rule.noTax) return 'nessuna sales tax statale';
			const parts = [];
			if (rule.amount) parts.push(usdFormat.format(rule.amount));
			if (rule.transactions) parts.push(`${rule.transactions} ordini`);
			return `${parts.join(rule.and ? ' e ' : ' o ')}${rule.period === 'rolling' ? ' in 12 mesi' : ''}`;
		},
	},
};
</script>

<style scoped>
.fo-code {
	font-family: monospace;
	font-size: 12px;
	color: #5f6b7a;
}
.fo-muted {
	font-size: 12px;
	color: #5f6b7a;
}
</style>
